import { Box, Checkbox } from "@drone-js/core";
import type { PropertyData } from "libs/codegen/property-onboarding";
import isEmpty from "lodash/isEmpty";
import { useFormContext } from "react-hook-form";
import { useFormController } from "../form/useFormController";
import { useMetadataAtomValue } from "../metadataAtom";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const ContractCheckboxController = () => {
    const { formState } = useFormContext<PropertyData>();
    const { value, setValue, ref } = useFormController("contractId");
    const {
        contractDetail: { id },
    } = useStaticDataAtomValue();
    const { isInternalUser } = useMetadataAtomValue();

    const isSelected = !isEmpty(value);

    const handleClick = () => {
        if (!isInternalUser) setValue(!isSelected ? id : "");
    };

    return (
        <Box onClick={handleClick} data-element-name="ack-terms-conditions">
            <Checkbox
                ref={ref}
                selection={isSelected ? "selected" : "unselected"}
                state={formState.isLoading || isInternalUser ? "disabled" : "enabled"}
            />
        </Box>
    );
};
